import { isSafari } from './platform';

export function openLink(url: string, isNewTab = false) {
  if (isSafari()) {
    const newTab = window.open(url, isNewTab ? '_blank' : '_self');
    return newTab !== null;
  }

  const a = document.createElement('a');
  a.href = url;
  a.target = isNewTab ? '_blank' : '_self';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();

  void Promise.resolve().finally(() => {
    document.body.removeChild(a);
  });

  return true;
}
